import { render, staticRenderFns } from "./CargoType.vue?vue&type=template&id=5cb29ebb&"
import script from "./CargoType.vue?vue&type=script&lang=js&"
export * from "./CargoType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports